export default __webpack_public_path__ + "static/media/You-Have-A-Call.855677d2.mp3";